<template>
  <Bar
    v-if="loadReady"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChartBasic",
  components: { Bar },
  props: {
    data: Array,
    label: String,
    width: String,
    height: String,
    chartId: {
      type: String,
      default: "bar-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    },
    showTrend: {
      type: Boolean,
      default: false
    },
    trendLabel: {
      type: String,
      default: "Trendi"
    }
  },
  data() {
    return {
      loadReady: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "SS",
            backgroundColor: "#f87979",
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  created: function() {
    console.log();
  },
  mounted() {
    this.fillChart();
    this.loadReady = true;
  },
  methods: {
    fillChart() {
      this.data.forEach(element => {
        this.chartData.labels.push(element.eventday);
        this.chartData.datasets[0].data.push(element.eventcount);
        this.chartData.datasets[0].label = this.label;
      });

      if (this.showTrend) {
        this.chartData.datasets.push({
          type: "line",
          label: this.trendLabel,
          data: this.calculateTrend(this.chartData.datasets[0].data),
          borderColor: "#4e73df",
          backgroundColor: "#4e73df",
          borderWidth: 2,
          pointRadius: 0,
          fill: false,
          order: 0
        });
      }
    },
    // Least-squares linear regression used to plot a trend line over the bar values
    calculateTrend(values) {
      const n = values.length;
      if (n === 0) return [];

      const xSum = values.reduce((sum, _, i) => sum + i, 0);
      const ySum = values.reduce((sum, v) => sum + v, 0);
      const xySum = values.reduce((sum, v, i) => sum + i * v, 0);
      const xxSum = values.reduce((sum, _, i) => sum + i * i, 0);

      const denominator = n * xxSum - xSum * xSum;
      const slope = denominator === 0 ? 0 : (n * xySum - xSum * ySum) / denominator;
      const intercept = (ySum - slope * xSum) / n;

      return values.map((_, i) => slope * i + intercept);
    },
  }
};
</script>
